import KeyIcon from '@mui/icons-material/Key'
import PhoneIcon from '@mui/icons-material/Phone'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { Box, Container, IconButton, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import qs from 'qs'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import {
  changePassword,
  getError,
  getIsPasswordChanged,
  getMessage,
  getPhoneNumber,
  receiveAppToken,
  setError,
  setIsReceivedSmsReset,
  setMessage,
} from '../../store/auth'
// Define interface and  validationSchema form
interface FormValues {
  phoneNumber: string
  confirmationCode: string
  password: string
}

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string().required().label('phoneNumber'),
  confirmationCode: Yup.string().max(6).required().label('confirmationCode'),
  password: Yup.string().required().label('password'),
})
interface State {
  password: string
  showPassword: boolean
}

const ChangePasswordScreen: React.FC = () => {
  // States Components
  const [values, setValues] = React.useState<State>({
    password: '',
    showPassword: false,
  })
  const location = useLocation()
  // Selectors Components
  const error = useSelector(getError)
  const phoneNumber = useSelector(getPhoneNumber)
  const message = useSelector(getMessage)

  const { enqueueSnackbar } = useSnackbar()
  // Define initialValues formik
  const initialValues: FormValues = {
    phoneNumber,
    confirmationCode: '',
    password: '',
  }
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch<any>>()
  const isPasswordChanged = useSelector(getIsPasswordChanged)
  const navigate = useNavigate()
  // useEffect
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (phoneNumber === undefined) navigate(`/${routes.LOGIN}`)
  }, [phoneNumber])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    navigate(`/${routes.LOGIN}`)
    // navigate(`/${routes.CARS}`)
  }, [message])
  useEffect(() => {
    if (isPasswordChanged === false) return
    const a = swal('تغییر رمز عبور با موفقیت انجام شد', 'جهت ادامه کلیک کنید', 'success')
    navigate(`/${routes.LOGIN}`, { replace: true })
  }, [isPasswordChanged])
  // Event Handler
  const handleSubmit = (values: any) => {
    dispatch(changePassword(values))
  }
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    })
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  window.onbeforeunload = () => "If you leave this page, you'll also leave the call"
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])

  useEffect(() => {
    return () => {
      dispatch(setIsReceivedSmsReset)
    }
  }, [])

  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Box display='flex' justifyContent='center'>
          <img alt='Logo' src='images/Logo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1 }}>
          <Typography sx={{ color: 'grey.700' }} variant='h5'>
            {t('screens.auth.ChangePasswordScreen.title')}
          </Typography>
        </Box>
        <Box sx={{ direction: 'ltr' }}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <FormField
              disabled
              name='phoneNumber'
              placeholder={t('screens.auth.ChangePasswordScreen.phoneNumber_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon />
                </InputAdornment>
              }
              sx={{ backgroundColor: 'white' }}
            />
            <FormField
              name='confirmationCode'
              placeholder={t('screens.auth.ChangePasswordScreen.confirmationCode_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <KeyIcon />
                </InputAdornment>
              }
            />
            <FormField
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    edge='end'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              name='password'
              placeholder={t('screens.auth.ChangePasswordScreen.password_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <KeyIcon />
                </InputAdornment>
              }
              type={values.showPassword ? 'text' : 'password'}
            />
            <SubmitButton title={t('screens.auth.ChangePasswordScreen.change_button_text')} />
          </Form>
        </Box>
      </Box>
    </Container>
  )
}

export default ChangePasswordScreen
